import ApartmentIcon from "@mui/icons-material/Apartment";
import CropFreeIcon from '@mui/icons-material/CropFree';
import DashboardIcon from "@mui/icons-material/Dashboard";
import PlaylistPlayIcon from "@mui/icons-material/PlaylistPlay";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import {
  DASHBOARD,
  ETATPARC,
  MAINTENANCE,
  PLAN,
  TASKS,
} from "constants/api/routeGlobals";
import { app_version } from "constants/globals";
import { JSX } from "react";
import SideBarButtons from "./SidebarButton";

export default function SideBar(): JSX.Element {
  const dashboardButtonTitle = "Tableau de bord";
  const planButtonTitle = "Plan de l'entrepôt";
  const etatParcButtonTitle = "États des parcs";
  const liveTasksButtonTitle = "Tâches en cours";
  const maintenanceButtonTitle = "Maintenance";

  return (
    <div className="app-navigation-container">
      <div className="app-navigation-items">
        <SideBarButtons
          title={dashboardButtonTitle}
          link={"/" + DASHBOARD}
          icon={<DashboardIcon />}
        />
        <SideBarButtons
          title={planButtonTitle}
          link={"/" + PLAN}
          icon={<ApartmentIcon />}
        />
        <SideBarButtons
          title={etatParcButtonTitle}
          link={"/" + ETATPARC}
          icon={<CropFreeIcon />}
        />
        <SideBarButtons
          title={liveTasksButtonTitle}
          link={"/" + TASKS}
          icon={<PlaylistPlayIcon />}
        />
        <SideBarButtons
          title={maintenanceButtonTitle}
          link={"/" + MAINTENANCE}
          icon={<WarningAmberIcon />}
        />
      </div>
      <div id="app-version">Version <br />{app_version}</div>
    </div>
  );
}
